import React from "react";
import RonaldPhoto from '../../assets/img/ronaldpassphoto.png';
import AntonyPhoto from '../../assets/img/antonypassport.jpg';

const founders = [
  {
    name: "Ronald Wekesa Wafula",
    title: "Co-Founder, CEO & CTO",
    photo: RonaldPhoto,
    bio: "Ronald has over 10 years of experience building scalable software solutions. He designed and developed the entire MastaKash platform, combining deep expertise in finance, technology, and entrepreneurship to solve trust, governance, and transparency challenges in community finance."
  },
  {
    name: "Antony Luvale Shivere",
    title: "Co-Founder & CMO",
    photo: AntonyPhoto,
    bio: "Antony brings expertise in market research, community engagement, and partnerships. He validated MastaKash with real groups and SACCO networks, funded operations, and helped structure regulatory compliance to ensure the platform meets the actual needs of communities."
  }
];

const FoundersSection = () => {
  return (
    <section className="bg-white py-20">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <h2 className="text-4xl font-bold text-purple-900 mb-12">Founding Team</h2>

        <div className="grid gap-12 md:grid-cols-2">
          {founders.map((founder, index) => (
            <div key={index} className="bg-purple-50 rounded-2xl shadow-lg p-8 flex flex-col items-center text-center hover:shadow-2xl transition-shadow duration-300">
              <img
                src={founder.photo}
                alt={founder.name}
                className="w-40 h-40 rounded-full object-cover mb-6 border-4 border-orange-500"
              />
              <h3 className="text-2xl font-semibold text-purple-900">{founder.name}</h3>
              <p className="text-orange-500 font-medium mb-4">{founder.title}</p>
              <p className="text-purple-800 text-base">{founder.bio}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FoundersSection;
